import React, { useState, useEffect } from 'react';
import s from './Logging.module.css';
import { logsApi } from '../../../api/logs';
import { Log } from '../../../types/api.types';

export const AdminLogging: React.FC = () => {
    const [logs, setLogs] = useState<Log[]>([]);
    const [loading, setLoading] = useState(true);
    const [filterAction, setFilterAction] = useState<string>('all');
    const [filterUser, setFilterUser] = useState<string>('all');

    useEffect(() => {
        loadLogs();
    }, []);

    const loadLogs = async () => {
        try {
            setLoading(true);
            const data = await logsApi.getAll();
            setLogs(data);
        } catch (error) {
            console.error('Ошибка загрузки логов:', error);
        } finally {
            setLoading(false);
        }
    };

    const getActionClass = (action: string): string => {
        switch (action) {
            case 'CREATE': return 'actionCreate';
            case 'UPDATE': return 'actionUpdate';
            case 'DELETE': return 'actionDelete';
            default: return '';
        }
    };

    const getActionLabel = (action: string): string => {
        switch (action) {
            case 'CREATE': return 'Создал';
            case 'UPDATE': return 'Изменил';
            case 'DELETE': return 'Удалил';
            default: return action;
        }
    };

    const filteredLogs = logs.filter(log => {
        const actionMatch = filterAction === 'all' || log.action === filterAction;
        const userMatch = filterUser === 'all' || log.userName === filterUser;
        return actionMatch && userMatch;
    });

    const uniqueUsers: string[] = [];
    logs.forEach(log => {
        if (!uniqueUsers.includes(log.userName)) {
            uniqueUsers.push(log.userName);
        }
    });

    if (loading) {
        return <div className={s.loading}>Загрузка...</div>;
    }

    return (
        <div className={s.logging}>
            <div className={s.header}>
                <h1 className={s.title}>Логирование</h1>
                <div className={s.filters}>
                    <select
                        className={s.filterSelect}
                        value={filterAction}
                        onChange={(e) => setFilterAction(e.target.value)}
                    >
                        <option value="all">Все действия</option>
                        <option value="CREATE">Создание</option>
                        <option value="UPDATE">Изменение</option>
                        <option value="DELETE">Удаление</option>
                    </select>
                    <select
                        className={s.filterSelect}
                        value={filterUser}
                        onChange={(e) => setFilterUser(e.target.value)}
                    >
                        <option value="all">Все пользователи</option>
                        {uniqueUsers.map(user => (
                            <option key={user} value={user}>{user}</option>
                        ))}
                    </select>
                </div>
            </div>

            <div className={s.tableWrapper}>
                <table className={s.table}>
                    <thead>
                    <tr>
                        <th>Пользователь</th>
                        <th>Действие</th>
                        <th>Объект</th>
                        <th>Дата</th>
                        <th>Время</th>
                    </tr>
                    </thead>
                    <tbody>
                    {filteredLogs.map(item => {
                        const date = new Date(item.dateCreating);
                        const dateStr = date.toLocaleDateString('ru-RU');
                        const timeStr = date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });

                        return (
                            <tr key={item.id}>
                                <td className={s.userCell}>
                                    <span className={s.userBadge}>{item.userName}</span>
                                </td>
                                <td>
                                        <span className={`${s.actionBadge} ${s[getActionClass(item.action)]}`}>
                                            {getActionLabel(item.action)}
                                        </span>
                                </td>
                                <td className={s.targetCell}>{item.target}</td>
                                <td>{dateStr}</td>
                                <td>{timeStr}</td>
                            </tr>
                        );
                    })}
                    {filteredLogs.length === 0 && (
                        <tr>
                            <td colSpan={5} className={s.emptyRow}>Нет записей</td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};